module.exports = __webpack_public_path__ + "static/media/live_streaming_zixi.cc219d39.svg";